import React from "react";

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center">
      <div className="w-6 h-6 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
    </div>
  );
}
